import { Component } from 'react';

import { Button, Modal } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';

import CustomIcon from '../../../common/CustomIcons';
import { isDuplicate } from '../../utils';
import AccountAssocView from '../AccountAssocView';
import AccountCascadingDropdown from '../AccountCascadingDropdown';

import './styles/index.css';

class RegionalAccountCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userAccountsEdit: false,
      removeAccount: false
    };
  }

  componentDidMount() {
    this.handleAssignAssociationEdit();
  }

  handleAssignAssociationEdit = () => {
    const {
      regAcc: { soldTos = [] }
    } = this.props;
    const selectedSoldTos = soldTos.filter(s => s.selected);
    this.setState({
      userAccountsEdit: !selectedSoldTos.length
    });
  };

  handleAccountEdit = () => {
    this.setState({
      userAccountsEdit: true
    });
  };

  cancelEdit = () => {
    const { cancelAssociationEdit, accountId } = this.props;
    this.setState(
      {
        userAccountsEdit: false
      },
      () => cancelAssociationEdit(accountId)
    );
  };

  handleRemoveModal = () => {
    this.setState(prevState => {
      const removeAccount = !prevState.removeAccount;
      return {
        ...prevState,
        removeAccount
      };
    });
  };

  validateData = accDetails => {
    const {
      isAssociationsUpdated,
      submitUpdatedAssociations,
      throwDuplicateError,
      minimumSelectionError,
      updatedAssociations,
      accIndex,
      regIndex
    } = this.props;
    const { value: sfid, label } = accDetails;

    if (isAssociationsUpdated) {
      const regionalSoldTo = updatedAssociations[accIndex].regionalAccounts[regIndex];

      let isSelectionError = true;
      const leastSelected = regionalSoldTo.soldTos.some(soldObj => soldObj.selected);
      if (leastSelected && regionalSoldTo.soldTos.length) {
        regionalSoldTo.soldTos.every(soldObj => {
          if (soldObj.selected) {
            isSelectionError = soldObj.shipTos.some(shipObj => {
              if (shipObj.selected) {
                isSelectionError = shipObj.salesArea.some(salesObj => salesObj.selected);
              } else {
                isSelectionError = false;
              }
              return isSelectionError;
            });
          } else {
            isSelectionError = true;
          }
          return isSelectionError;
        });
      }

      minimumSelectionError(!isSelectionError);

      const duplicate = isDuplicate(regionalSoldTo.soldTos);
      throwDuplicateError(duplicate);

      if (duplicate || !isSelectionError) {
        const scrollTo = document.getElementById('user-account-container');
        scrollTo.scrollIntoView();
      } else {
        submitUpdatedAssociations(sfid, label);
        this.setState({
          userAccountsEdit: false
        });
      }
    } else {
      this.setState({
        userAccountsEdit: false
      });
    }
  };

  handleRemoveAccount = (accIndex, sfid) => {
    const { removeRegionalAccount } = this.props;
    removeRegionalAccount(accIndex, sfid);
  };

  render() {
    const { userAccountsEdit, removeAccount } = this.state;
    const {
      userAccAssocLabels,
      regAcc,
      isPrimary,
      updateAssociationSelection,
      regIndex,
      accIndex,
      userAssociations,
      isEditable,
      isProfile
    } = this.props;
    const { removeRegAccount, editAccount, removeAccMsg, no, yes, cancel, save } = userAccAssocLabels;
    return (
      <>
        {userAccountsEdit && !isProfile ? (
          <div className="user-acc-region">
            <div className="edit-header">
              {!isPrimary && (
                <Button classes="removeRegBtn btnBoxless" type="button" handleClick={this.handleRemoveModal}>
                  {`(${removeRegAccount})`}
                </Button>
              )}
            </div>
            <AccountCascadingDropdown
              regIndex={regIndex}
              accIndex={accIndex}
              userAssociations={userAssociations}
              regSoldTos={regAcc.soldTos}
              userAccAssocLabels={userAccAssocLabels}
              handleAssociationSelection={updateAssociationSelection}
            />

            <div className="action-container">
              <Button classes="btn btn-light" type="button" handleClick={this.cancelEdit} buttonLabel={cancel} />
              <Button
                classes="btn btn-color"
                type="button"
                handleClick={() => this.validateData(regAcc)}
                regIndex={regIndex}
                accIndex={accIndex}
                buttonLabel={save}
              />
            </div>
            {removeAccount && (
              <Modal>
                <div className="um-shade">
                  <div className="overlay lights-off" role="presentation">
                    <p className="alpha b">{removeAccMsg}</p>
                    <div className="overlay-actionArea lights-off">
                      <Button classes="btn btn-dark cancel" type="button" handleClick={this.handleRemoveModal}>
                        {no}
                      </Button>
                      <Button
                        classes="btn btn-dark confirm"
                        type="button"
                        handleClick={() => this.handleRemoveAccount(accIndex, regAcc.value)}
                      >
                        {yes}
                      </Button>
                    </div>
                  </div>
                </div>
              </Modal>
            )}
          </div>
        ) : (
          <div className="user-acc-region">
            <div className="view-header">
              {isEditable && !isProfile && (
                <Button classes="editBtn btnBoxless" type="button" handleClick={this.handleAccountEdit}>
                  <span>{editAccount}</span>
                  <CustomIcon type="edit" size="18" className="edit-icon" />
                </Button>
              )}
            </div>
            <AccountAssocView regionAccount={regAcc} userAccAssocLabels={userAccAssocLabels} />
          </div>
        )}
      </>
    );
  }
}

RegionalAccountCard.propTypes = {
  accountId: PropTypes.string.isRequired,
  accIndex: PropTypes.number.isRequired,
  cancelAssociationEdit: PropTypes.func,
  isAssociationsUpdated: PropTypes.bool.isRequired,
  isPrimary: PropTypes.bool,
  isEditable: PropTypes.bool,
  isProfile: PropTypes.bool,
  minimumSelectionError: PropTypes.func.isRequired,
  regAcc: PropTypes.instanceOf(Object),
  regIndex: PropTypes.number.isRequired,
  removeRegionalAccount: PropTypes.func.isRequired,
  submitUpdatedAssociations: PropTypes.func,
  throwDuplicateError: PropTypes.func.isRequired,
  updatedAssociations: PropTypes.instanceOf(Object),
  updateAssociationSelection: PropTypes.func,
  userAccAssocLabels: PropTypes.instanceOf(Object).isRequired,
  userAssociations: PropTypes.instanceOf(Array).isRequired
};

RegionalAccountCard.defaultProps = {
  cancelAssociationEdit: () => {},
  isPrimary: false,
  regAcc: {},
  submitUpdatedAssociations: () => {},
  updatedAssociations: {},
  updateAssociationSelection: () => {},
  isEditable: false,
  isProfile: false
};

export default RegionalAccountCard;
